import React from 'react';

const PoliticaPrivacidadPage: React.FC = () => (
  <div style={{ maxWidth: 700, margin: '40px auto', background: '#fff', borderRadius: 8, padding: 32, boxShadow: '0 2px 16px rgba(0,0,0,0.08)' }}>
    <h1>Política de Privacidad</h1>
    <p>
      Esta aplicación respeta y protege la privacidad de los usuarios. Los datos recolectados se utilizan únicamente para el funcionamiento y mejora del servicio, y no se comparten con terceros salvo obligación legal. Para más información, contacte al responsable del proyecto.
    </p>
    <p>
      Al utilizar esta aplicación, usted acepta los términos de esta política de privacidad.
    </p>
  </div>
);

export default PoliticaPrivacidadPage;
